module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/wine_3dd583.jpg";